<template>
  <section class="custom-wrapper">
    <div class="row custom-chart">
      <vue-highcharts
        type="chart"
        :options="chartOptions"
        :redrawOnUpdate="true"
        :oneToOneUpdate="false"
        :animateOnUpdate="true"
      />
      <span
        class="custom-viewed"
        :title="'viewed ' + viewCount.viewed + ' out of ' + viewCount.total"
        >{{ viewCount.viewed }}/{{ viewCount.total }}</span
      >
    </div>
    <span class="custom-title">{{ componentName }}</span>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import VueHighcharts from 'vue3-highcharts'
export default {
  name: 'component-gauge',
  components: {
    VueHighcharts,
  },
  props: {
    componentName: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('dashboardComponents', ['memberStatus']),
    viewCount() {
      let _data = {
        viewed: 0,
        total: 0,
      }
      if (this.memberStatus) {
        let cnt = 0
        let total = 0
        this.memberStatus.forEach((element) => {
          if (element.componentName === this.componentName) {
            total = element.componentTarget
            if (element.progressDate !== null) {
              cnt++
            }
          }
        })
        _data = {
          viewed: cnt,
          total: total,
        }
      }
      return _data
    },
    chartOptions() {
      let colors = ['#707070', '#169900']
      let data = []
      let viewCount = this.viewCount
      data.push(viewCount.total - viewCount.viewed)
      data.push(viewCount.viewed)
      let options = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
          height: 140,
          width: 140,
          className: 'custom-highcharts',
        },
        plotOptions: {
          pie: {
            dataLabels: {
              enabled: false,
            },
          },
        },
        title: {
          text: '',
        },
        legend: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        tooltip: {
          enabled: false,
        },
        colors: colors,
        series: [
          {
            type: 'pie',
            innerSize: '70%',
            data: data,
          },
        ],
      }
      return options
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  width: 100%;
  text-align: center;
}
.custom-chart {
  position: relative;
  text-align: center;
  padding-left: 0px;
  padding-right: 0px;
  div {
    position: relative;
    bottom: 0px;
  }
  span {
    position: absolute;
    text-align: center;
    margin: 0 auto;
    font-size: 1.8em;
    left: 0;
    top: 44px;
    width: 100%;
  }
}
.custom-viewed {
  cursor: default;
}
.custom-title {
  text-align: center;
  font-size: 1.1em;
  font-weight: 600;
}
</style>
